export default function PillList({ pills = [] }) {
  if (!Array.isArray(pills) || pills.length === 0) {
    return null;
  }

  return (
    <div className="savora-pill-list">
      {pills.map((pill, index) => {
        const label = typeof pill?.label === 'string' ? pill.label.trim() : '';
        const className = typeof pill?.className === 'string' ? pill.className.trim() : '';

        if (!label) {
          return null;
        }

        return (
          <span key={`${label}-${index}`} className={`savora-pill ${className}`}>
            {label}
          </span>
        );
      })}
    </div>
  );
}
